module.exports = __webpack_public_path__ + "static/img/swiper20.fca1ec43.png";